/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Result of outbound integration execution
 * @export
 * @interface OutboundExecutionResult
 */
export interface OutboundExecutionResult {
    /**
     * Workflow execution ID
     * @type {string}
     * @memberof OutboundExecutionResult
     */
    executionId?: string;
    /**
     * Integration instance ID
     * @type {string}
     * @memberof OutboundExecutionResult
     */
    instanceId?: string;
    /**
     * Entity type synced
     * @type {string}
     * @memberof OutboundExecutionResult
     */
    entityType?: string;
    /**
     * Number of entities processed
     * @type {number}
     * @memberof OutboundExecutionResult
     */
    entitiesProcessed?: number;
    /**
     * Number of entities successfully synced
     * @type {number}
     * @memberof OutboundExecutionResult
     */
    entitiesSynced?: number;
    /**
     * Number of entities that failed to sync
     * @type {number}
     * @memberof OutboundExecutionResult
     */
    entitiesFailed?: number;
    /**
     * Number of conflicts detected
     * @type {number}
     * @memberof OutboundExecutionResult
     */
    conflictsDetected?: number;
    /**
     * Number of conflicts resolved
     * @type {number}
     * @memberof OutboundExecutionResult
     */
    conflictsResolved?: number;
    /**
     * Whether execution was successful
     * @type {boolean}
     * @memberof OutboundExecutionResult
     */
    success?: boolean;
    /**
     * Execution start time
     * @type {Date}
     * @memberof OutboundExecutionResult
     */
    startTime?: Date;
    /**
     * Execution end time
     * @type {Date}
     * @memberof OutboundExecutionResult
     */
    endTime?: Date;
    /**
     * Execution duration in milliseconds
     * @type {number}
     * @memberof OutboundExecutionResult
     */
    durationMs?: number;
    /**
     * Error message if failed
     * @type {string}
     * @memberof OutboundExecutionResult
     */
    errorMessage?: string;
    /**
     * Suppression reason when outbound was skipped by policy (e.g. SUPPRESSED_PRIMARY_POLICY)
     * @type {string}
     * @memberof OutboundExecutionResult
     */
    suppressedReason?: string;
}

/**
 * Check if a given object implements the OutboundExecutionResult interface.
 */
export function instanceOfOutboundExecutionResult(value: object): value is OutboundExecutionResult {
    return true;
}

export function OutboundExecutionResultFromJSON(json: any): OutboundExecutionResult {
    return OutboundExecutionResultFromJSONTyped(json, false);
}

export function OutboundExecutionResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutboundExecutionResult {
    if (json == null) {
        return json;
    }
    return {
        
        'executionId': json['executionId'] == null ? undefined : json['executionId'],
        'instanceId': json['instanceId'] == null ? undefined : json['instanceId'],
        'entityType': json['entityType'] == null ? undefined : json['entityType'],
        'entitiesProcessed': json['entitiesProcessed'] == null ? undefined : json['entitiesProcessed'],
        'entitiesSynced': json['entitiesSynced'] == null ? undefined : json['entitiesSynced'],
        'entitiesFailed': json['entitiesFailed'] == null ? undefined : json['entitiesFailed'],
        'conflictsDetected': json['conflictsDetected'] == null ? undefined : json['conflictsDetected'],
        'conflictsResolved': json['conflictsResolved'] == null ? undefined : json['conflictsResolved'],
        'success': json['success'] == null ? undefined : json['success'],
        'startTime': json['startTime'] == null ? undefined : (new Date(json['startTime'])),
        'endTime': json['endTime'] == null ? undefined : (new Date(json['endTime'])),
        'durationMs': json['durationMs'] == null ? undefined : json['durationMs'],
        'errorMessage': json['errorMessage'] == null ? undefined : json['errorMessage'],
        'suppressedReason': json['suppressedReason'] == null ? undefined : json['suppressedReason'],
    };
}

export function OutboundExecutionResultToJSON(json: any): OutboundExecutionResult {
    return OutboundExecutionResultToJSONTyped(json, false);
}

export function OutboundExecutionResultToJSONTyped(value?: OutboundExecutionResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'executionId': value['executionId'],
        'instanceId': value['instanceId'],
        'entityType': value['entityType'],
        'entitiesProcessed': value['entitiesProcessed'],
        'entitiesSynced': value['entitiesSynced'],
        'entitiesFailed': value['entitiesFailed'],
        'conflictsDetected': value['conflictsDetected'],
        'conflictsResolved': value['conflictsResolved'],
        'success': value['success'],
        'startTime': value['startTime'] == null ? undefined : ((value['startTime']).toISOString()),
        'endTime': value['endTime'] == null ? undefined : ((value['endTime']).toISOString()),
        'durationMs': value['durationMs'],
        'errorMessage': value['errorMessage'],
        'suppressedReason': value['suppressedReason'],
    };
}

